var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "26",
      "height": "26",
      "fill": "none"
    }
  }, _vm.$listeners), [_c('path', {
    attrs: {
      "fill": "#fff",
      "fill-opacity": ".2",
      "d": "m3.537 12.8 1.667 1.6c4.142-3.976 10.858-3.976 15 0l1.667-1.6c-5.059-4.856-13.267-4.856-18.334 0m6.667 6.4 2.5 2.4 2.5-2.4c-1.375-1.328-3.617-1.328-5 0M6.871 16l1.666 1.6c2.3-2.208 6.034-2.208 8.334 0l1.666-1.6c-3.216-3.088-8.441-3.088-11.666 0"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FFE86C",
      "fill-rule": "evenodd",
      "d": "M12.302 16.744c-.33 0-.549-.206-.549-.464V9.476c0-.258.275-.464.55-.464.329 0 .549.206.549.464v6.804c0 .258-.276.464-.55.464",
      "clip-rule": "evenodd"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#FFE86C",
      "stroke-width": ".8",
      "d": "M12.302 16.744c-.33 0-.549-.206-.549-.464V9.476c0-.258.275-.464.55-.464.329 0 .549.206.549.464v6.804c0 .258-.276.464-.55.464"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FFE86C",
      "fill-rule": "evenodd",
      "d": "M12.302 18.445c.546 0 .988.415.988.927 0 .513-.442.93-.988.93-.545 0-.987-.417-.987-.93 0-.512.442-.927.987-.927",
      "clip-rule": "evenodd"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#FFE86C",
      "stroke-width": ".8",
      "d": "M12.302 18.445c.546 0 .988.415.988.927 0 .513-.442.93-.988.93-.545 0-.987-.417-.987-.93 0-.512.442-.927.987-.927"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FFE86C",
      "fill-rule": "evenodd",
      "d": "M1.976 22.195h21.182L12.568 4.49zm21.924.815H1.234a.44.44 0 0 1-.375-.202.39.39 0 0 1-.003-.405L12.188 3.459c.154-.256.604-.256.758 0L24.28 22.403a.39.39 0 0 1-.004.405.44.44 0 0 1-.375.202z",
      "clip-rule": "evenodd"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FFE86C",
      "d": "m1.976 22.195-.343-.206-.362.606h.705zm21.182 0v.4h.706l-.363-.606zM12.568 4.49l.343-.205-.343-.574-.344.574zM.859 22.808l.34-.21zm-.003-.405-.344-.206zM12.188 3.459l-.343-.206zm.758 0 .343-.205v-.001zM24.28 22.403l.343-.206zm-.004.405-.339-.213-.001.003zm-22.299-.213h21.182v-.8H1.976v.8zm21.525-.606L12.911 4.286l-.687.41L22.814 22.4zM12.224 4.286 1.633 21.989l.687.411L12.91 4.697zM23.9 22.61H1.234v.8H23.9zm-22.666 0a.1.1 0 0 1-.027-.006l-.007-.005-.681.42a.84.84 0 0 0 .715.391zm-.035-.013.001.005v.004l-.001.002-.687-.41a.79.79 0 0 0 .008.821zm0 .011L12.532 3.664l-.687-.41L.512 22.197zM12.53 3.665c-.007.011-.013.013-.007.01a.1.1 0 0 1 .043-.008q.031.001.043.008c.006.003 0 .001-.007-.01l.686-.412c-.168-.28-.472-.386-.722-.386s-.553.106-.722.386zm.072 0 11.332 18.943.687-.41L13.289 3.253l-.686.41zm11.332 18.943v-.005l.001-.007.678.425c.16-.254.16-.57.008-.824zm0-.01-.002.002-.006.004a.1.1 0 0 1-.027.006v.8c.283 0 .56-.14.715-.392z"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }